import React from 'react'
import {FaFacebook,FaTwitter,FaLinkedin} from 'react-icons/fa'

export const socialLinks=[
    {
        id:1,
        icon:<FaFacebook className="icon"/>,
        path:"https://www.facebook.com/ahmedmuhammedelsaid"
    },
    {
        id:2,
        icon:<FaTwitter className="icon"/>,
        pat:"https://twitter.com/AhmedMSaid1111"
    }
    ,{
        id:3,
        icon:<FaLinkedin className="icon"/>,
        path:"https://www.linkedin.com/in/ahmedmuhammedelsaid/"
    }
]